/**
 * Product feature switches - build-time constants, one place.
 *
 * FIRST_PARTY_LISTINGS: the "post your own listing" surface (wizard at
 * /profile/listings/new, the manage page, nav entries, the trust block in
 * the home listings tile). Cut 2026-07-17, re-enabled 2026-07-18 with
 * the trust layer (publication terms, renewal, reports, admin queue,
 * tap-to-reveal phone, /l/[id]), cut AGAIN 2026-07-19 (owner call):
 * launch waits on a real SMS gateway for the OTP step (the backend now
 * refuses verification in production without one) and a deliberate
 * relaunch decision. Flip back to true when both exist.
 */
export const FIRST_PARTY_LISTINGS = false;
